'use client'

import { Card, Cell, Text, Spacer, Container } from '@vinted/web-ui'
import { useIntl } from 'react-intl'

import { ClosetPromoPerformanceModel } from '@marketplace-web/vas/vas-data'
import { useTranslate } from '@marketplace-web/shared/i18n'
import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

import ImpressionsAreaChart from './ImpressionsAreaChart'
import { calculateMetricTotals } from '../../../utils/closetPromoPerformance'

type Props = {
  performance: ClosetPromoPerformanceModel
}

const Views = ({ performance }: Props) => {
  const translate = useTranslate('closet_promotion.performance.views')
  const { formatNumber } = useIntl()
  const breakpoints = useBreakpoint()

  const metricTotals = calculateMetricTotals(performance.impressionsPerDay)

  const renderTitle = () => {
    const titleText = translate(
      'header',
      { count: undefined },
      { count: metricTotals.promoted },
    ).trim()

    return (
      <>
        <Text
          as="span"
          type={Text.Type.Heading}
          text={formatNumber(metricTotals.promoted)}
          aria={{ 'aria-hidden': 'true' }}
        />
        <Spacer size={Spacer.Size.Small} orientation={Spacer.Orientation.Vertical} />
        <Text
          as="h2"
          type={Text.Type.Title}
          text={titleText}
          aria={{
            'aria-label': `${metricTotals.promoted} ${titleText}`,
          }}
        />
      </>
    )
  }

  return (
    <Card testId="closet-promo-stats-impressions-chart-block">
      <Container styling={breakpoints.tabletsUp ? Container.Styling.Wide : undefined}>
        <div className="u-phones-only">
          <Spacer size={Spacer.Size.Regular} />
        </div>
        <Cell
          styling={Cell.Styling.Tight}
          title={renderTitle()}
          body={<Text as="span" type={Text.Type.Subtitle} text={translate('subtitle')} />}
        />
        <Spacer size={Spacer.Size.Large} />
        <ImpressionsAreaChart
          metrics={performance.impressionsPerDay}
          updatedAt={performance.updatedAt}
        />
        <div className="u-phones-only">
          <Spacer size={Spacer.Size.Regular} />
        </div>
      </Container>
    </Card>
  )
}

export default Views
